import Image from 'next/image'

import { UIFeatureBlock } from '@/shared/ui/feature-block'

export const data = [
	{
		customIcon: (
			<Image
				src="https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/logos/apple/apple-logo-grey.svg"
				width={60}
				height={60}
				alt="apple"
			/>
		),
		heading: (
			<>
				Уже более 10 лет <br /> на&nbsp;рынке
			</>
		),
		description: (
			<>
				Мы&nbsp;являемся одним из&nbsp;крупнейших Apple Premium Reseller в&nbsp;России и&nbsp;продаём как технику Apple,
				так и&nbsp;товары других ведущих мировых брендов
			</>
		)
	},
	{
		icon: 'IPortEducation',
		heading: (
			<>
				Обучаем&nbsp;креативным <br /> практикам
			</>
		),
		description: <>Получите вдохновение и&nbsp;научитесь использовать возможности техники в&nbsp;Университете iPort</>
	},
	{
		icon: 'IPortTool',
		heading: (
			<>
				Забота о&nbsp;технике по&nbsp;высшим <br /> стандартам
			</>
		),
		description: <>Будьте спокойны за&nbsp;технику. Наши сервисные центры iPort гарантируют качество обслуживания</>
	},
	{
		icon: 'IPortLove',
		heading: (
			<>
				Индивидуальный <br /> подход
			</>
		),
		description: <>Персональные консультации, индивидуальные&nbsp;решения для личного использования и&nbsp;бизнеса</>
	}
] as UIFeatureBlock[]
